import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    padding: '0.5rem',
    borderRadius: '5px',
    cursor: 'pointer',

    '&:hover': {
      background: '#F5F6F8'
    }
  },

  checkbox: {
    padding: '0'
  },

  title: {
    fontSize: theme.size.sm,
    color: '#1F1F1F',
    userSelect: 'none'
  }
}))

export default useStyles
